import { headerMenu } from './modules/headerMenu';
import { hamburger } from './modules/hamburger';
import { numbers } from './modules/numbers';
import { scrollAnime } from './modules/scrollAnime';
import { loading } from './modules/loading';
import { form } from './modules/form';
headerMenu();
hamburger();
numbers();
scrollAnime();
loading();
form();